var _defs, _circle, _g, _rect, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUsButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 125.4 46.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        isolation: isolate;\n      }\n\n      .st1 {\n        stroke: #1e1e1e;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st1, .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: #f39744;\n      }\n\n      .st2 {\n        stroke: #f59740;\n        stroke-miterlimit: 10;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 103.5,
    cy: 23.1,
    r: 21.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 99.3,
    y1: 27.1,
    x2: 107.2,
    y2: 19.4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "99.8 19 107.6 19 107.6 26.6"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 0.9,
    y: 1.2,
    width: 123.6,
    height: 43.7,
    rx: 21.8,
    ry: 21.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4,18.1c1.2,0,2.1.4,2.8.9l-.5.9c-.6-.4-1.5-.7-2.3-.7-2.1,0-3.3,1.5-3.3,3.3s1.2,3.2,3.3,3.2,1.8-.3,2.3-.7l.5.9c-.7.5-1.5.9-2.8.9-2.9,0-4.5-2-4.5-4.3s1.7-4.3,4.5-4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,20.5c1.7,0,3.2,1.4,3.2,3.1s-1.4,3.1-3.2,3.1-3.1-1.4-3.1-3.1,1.4-3.1,3.1-3.1ZM24,25.7c1.1,0,2-.9,2-2.1s-.9-2.1-2-2.1-2,.9-2,2.1.9,2.1,2,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9,23.2c0-1.3-.6-1.7-1.2-1.7s-1.9.4-1.9,2.3v2.8h-1.2v-6h1.2v1.2c.3-.9,1-1.3,2-1.3s2.3.8,2.3,2.7v3.4h-1.2v-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2,24.8c0,.7.3.9.7.9s.7-.2.7-.7,0-.3,0-.5h1c.1.2.1.6.1.6,0,.9-.6,1.5-1.8,1.5s-1.9-.5-1.9-2v-3.2h-1v-.9h1l.3-1.7h.9v1.7h1.9v.9h-1.9v3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3,20.5c.8,0,1.6.3,2.2,1.1v-1h1.2v6h-1.2v-1c-.6.8-1.4,1.1-2.2,1.1-1.8,0-3-1.4-3-3.1s1.2-3.1,3-3.1ZM43.4,21.5c-1.2,0-2,1-2,2.1s.7,2.1,2,2.1,2-.9,2.1-2.1c0-1.2-.8-2.1-2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4,20.5c.5,0,1.3.1,2.1.7l-.6.8c-.6-.5-1.4-.5-1.5-.5-1.3,0-2.3.9-2.3,2.1s1,2.1,2.3,2.1.9,0,1.5-.5l.6.8c-.8.6-1.6.7-2.1.7-2.1,0-3.4-1.4-3.4-3.1s1.2-3.2,3.4-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3,24.8c0,.7.3.9.7.9s.7-.2.7-.7,0-.3,0-.5h1c.1.2.1.6.1.6,0,.9-.6,1.5-1.8,1.5s-1.9-.5-1.9-2v-3.2h-1v-.9h1l.3-1.7h.9v1.7h1.9v.9h-1.9v3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8,18.2v5.3c0,2.1-1.5,3.2-3.3,3.2s-3.3-1.1-3.3-3.2v-5.3h1.2v5.3c0,1.5,1,2.2,2.1,2.2s2.1-.7,2.1-2.2v-5.3h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3,22.1c-.2-.5-.6-.7-.9-.7-.5,0-.9.3-.9.8s.4.6.7.7l.9.3c1.1.3,1.4,1.1,1.4,1.7,0,1.1-1,1.8-2.2,1.8s-2-.5-2.3-1.6l1-.3c.1.5.7.8,1.3.8s1-.3,1-.8-.3-.6-.8-.8l-.8-.3c-1-.3-1.5-.8-1.5-1.6s.8-1.8,2-1.8,1.7.3,2,1.4l-1,.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUsButton);
export default __webpack_public_path__ + "static/media/Contact-Us-Button.c66f4821fc66842ba82b505843ea4b09.svg";
export { ForwardRef as ReactComponent };